import { createReducer } from 'utils/reducerGenerator';
import * as types from '../actions';
import { FETCHING_STATUS } from '../../../../constants';

export const reducer = createReducer({
  fetchingStatus: FETCHING_STATUS.INIT,
}, {
  [types.DOWNLOAD_LENDER_RECONCILIATION_REPORT_START]: () => ({
    fetchingStatus: FETCHING_STATUS.START,
  }),
  [types.DOWNLOAD_LENDER_RECONCILIATION_REPORT_FINISHED]: () => ({
    fetchingStatus: FETCHING_STATUS.SUCCESS,
  }),
});
